import { type FormikErrors } from 'formik';

import { type TGlobalFunctionTyped } from 'src/core/common/hooks/useTranslation';

import { type FormProps } from './StandardApprovalFlowPanelContent';

type FormErrors = FormikErrors<FormProps>;

export const validateForm = (
  values: FormProps,
  translator: TGlobalFunctionTyped,
): FormErrors => {
  const errors: FormErrors = {};
  if (values.approvalRules.length === 0) {
    errors.approvalRules = translator(
      'costCenters.form.errors.approvalFlowEmpty',
    );
    return errors;
  }

  if (
    values.approvalRules.some((rule) =>
      rule.steps.some((step) => step.rights.length === 0),
    )
  ) {
    errors.approvalRules = translator(
      'costCenters.form.errors.approvalFlowEmpty',
    );
    return errors;
  }

  const approvalRulesContainDuplicateApprovers = values.approvalRules.some(
    (approvalRule) => {
      const approverIds = approvalRule.steps.flatMap((step) => {
        return step.rights.map((right) => {
          if (right.approverType === 'user') {
            return `${right.approverType}-${right.approverId}`;
          }
          if (right.approverType === 'costCenterOwner') {
            return right.approverType;
          }
          if (right.approverType === 'reportingManager') {
            return right.approverType;
          }
          if (right.approverType === 'accountOwner') {
            return right.approverType;
          }
          return '';
        });
      });
      return approverIds.length !== new Set(approverIds).size;
    },
  );

  if (approvalRulesContainDuplicateApprovers) {
    errors.approvalRules = translator(
      'costCenters.form.errors.approvalFlowDuplicateApprovers',
    );
    return errors;
  }

  if (values.approvalRules.some(rule => !rule.steps.length)) {
    errors.approvalRules = translator(
      'teams.approvalFlows.requiredOneApprover',
    );
    return errors;
  }

  return errors;
};
